export const SHORT_SITE_URL: string = 'velatlas.com';
export const FULL_SITE_URL: string = 'https://www.velatlas.com';
export const SITE_NAME: string = 'Velatlas';
// export const VELATLAS_API_URL: string = 'http://localhost:8083';
export const VELATLAS_API_URL: string = 'https://api.velatlas.com';
export const ENABLE_LOGGING_TO_SERVER: boolean = true;
export const ENABLE_ANALYTICS_SENDING: boolean = true;
export const IMAGE_BASE_URL: string = 'https://media.velatlas.com';
export const MAP_LIBRE_STYLE: string = 'https://tiles.openfreemap.org/styles/liberty';
export const PAGE_ITEM_SIZES = {
    cities: 36,
    collections: 204,
}
export const MAX_SPOTLIGHT_ITEMS: number = 3;
export const MIN_COLLECTION_ITEMS_FOR_INDIVIDUAL_PAGE: number = 3;
export const MAX_IMAGES_PER_COLLECTION: number = 4;
export const PERSISTED_STATE_VISITED_CITIES: string = 'visited-cities';
export const TAILWIND_BREAKPOINT: TailwindBreakpoints = {
    sm: { minWidth: 640 },
    md: { minWidth: 768 },
    lg: { minWidth: 1024 },
    xl: { minWidth: 1280 },
};
export const WIKI_POINTS_SETTINGS = {
    topArticlesPercentile: 0.65, // 0.65 = 65th percentile
}

export enum ANALYTICS_EVENT_NAMES {
    pageEntry = 'pageEntry',
    pageEngagement = 'pageEngagement',
    featureTypeMapFilter = 'featureTypeMapFilter',
    emptySearch = 'emptySearch',
    wikiMapPoi = 'wikiMapPoi',
    cityViewed = 'cityViewed',
    imageOpened = 'imageOpened',
    imageClosed = 'imageClosed',
    galleryScrolled = 'galleryScrolled',
    readMore = 'readMore',
    scrollDepth = 'scrollDepth',
    externalClick = 'externalClick',
    placeDetailsOpened = 'placeDetailsOpened',
    random = 'random',
    themeToggle = 'themeToggle',
    filtered = 'filtered',
    tourPlayer = 'tourPlayer',
    routeShareOpened = 'routeShareOpened',
    botEntry = 'botEntry',
    videoPlay = 'videoPlay',
}

interface TailwindBreakpoints {
    sm: { minWidth: number };
    md: { minWidth: number };
    lg: { minWidth: number };
    xl: { minWidth: number };
}